import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface IConflictingSuggestionsModel {
  conflicting_resolution_ids: number[];
}

export type ConflictingSuggestionsModel = ITypedModel<IConflictingSuggestionsModel>;

angular.module('capability-ng-academic-planner').factory(
  'ngConflictingSuggestionsModel',
  (): ConflictingSuggestionsModel =>
    new Model<IConflictingSuggestionsModel>({
      conflicting_resolution_ids: []
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/models/conflicting_suggestions_model.ts